<template>
  <iframe
    ref="fullscreenIframe"
    :src="externalUrl"
    class="fullscreen-iframe"
    allow="scripts;camera;microphone"
    @load="handleIframeLoad"
  />
</template>
<script>
export default {
  data() {
    return {
      externalUrl: ''
    }
  },
  created() {
    this.externalUrl = this.$route.query.path
  },
  mounted() {
    window.addEventListener('message', event => {
      console.log(event, 'event--')
      if ((event.origin === 'https://www.medmeta.com' || event.origin ==='https://ykb.medmeta.com') && event.data === 'GO_HOME') {
        // window.location.href = 'http://192.168.120.50:8080/syIndex'
        // window.location.href = 'http://ykb-online-exam-test.yikaobang.com.cn/syIndex'
        window.location.href = window.location.origin.includes('ykb-online-exam-test')? 'https://ykb-online-exam-test.yikaobang.com.cn/syIndex' : 'https://ykb-online-exam.yikaobang.com.cn/syIndex'
        return
      } else if ((event.origin === 'https://www.medmeta.com' || event.origin ==='https://ykb.medmeta.com') && event.data === 'GO_LOGIN') {
        this.$store.dispatch('loginOut').then(res => {
          // window.location.href = 'http://192.168.120.50:8080/syIndex'
          // window.location.href = 'http://ykb-online-exam-test.yikaobang.com.cn/syIndex'
          window.location.href = window.location.origin.includes('ykb-online-exam-test')? 'https://ykb-online-exam-test.yikaobang.com.cn/syIndex' : 'https://ykb-online-exam.yikaobang.com.cn/syIndex'
        })
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('message');
  },
  methods: {
    handleIframeLoad() {
      window.addEventListener('message', (event) => {
        if (event.data?.type === 'resize') {
          this.$refs.fullscreenIframe.style.height = `${event.data.height}px`;
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
body,html{
    width: 100%;
    height: 100%;
}
.fullscreen-iframe{
    width: 100%;
    height: 100%;
}
</style>
